import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import { Grid, Stack, Toolbar, Typography, Box,Tooltip } from "@mui/material";
import logo from "./../images/logo.png";
import "./../header/Header.css";
import { ComBtn, ComButton } from "../commonFields/ComBtn";
import useMediaQuery from "@mui/material/useMediaQuery";
import { IconButton } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router-dom";


const Header = () => {
  const vMediaQuery = useMediaQuery("(max-width:600px)");
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate(); // Initialize the navigate function

  const [anchorEl, setAnchorEl] =useState(null);


  const handleClick = () => {
    const footerElement = document.getElementById('contactInfo'); // Get the footer element by ID
    if (footerElement) {
      footerElement.scrollIntoView({ behavior: 'smooth' }); // Scroll to the footer element
    }
  };

  const logoAction = () => {
      navigate('/home'); // Navigate to the About page when the button is clicked
      window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to the top of the page
    };

  const heading = {
    fontWeight: 800,
    fontSize: vMediaQuery ? "18px" : "48px",
    marginLeft: vMediaQuery ? "20px" : "0px",
    fontFamily: "EB Garamond",
    //marginTop:vMediaQuery?"6px":"0px",
    backgroundImage: "linear-gradient(45deg, #357ec7, #eaff63, green)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    textAlign: "center",
  };

  
  useEffect(() => {
    let scrollTimer = null;

    const handleScroll = () => {
      clearTimeout(scrollTimer); // Clear any existing timer

      scrollTimer = setTimeout(() => {
        if (window.scrollY > 0) {
          setIsScrolled(true);
        } else {
          setIsScrolled(false);
        }
      }, 500); // Set the delay in milliseconds
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(scrollTimer); // Clear the timer on unmount
    };
  }, []);

  return (
    <>
      <header className="about-header">
        <AppBar
          position="absolute"
          sx={{
            background: "transparent",
            boxShadow: 0,
            padding: vMediaQuery ? "6px" : "",
            display: isScrolled? "none":"block",

          }}
        >
          <Toolbar>
            <Grid container>
              <Grid item xs={2} md={3} lg={3}>
                <div className="logo-contanier">
                  <img className="logo" src={logo} alt="Logo" title="GDR Consultancy Services"  onClick={logoAction}/>
                </div>
              </Grid>
              <Grid
                item
                xs={8}
                md={6}
                lg={6}
                sx={{ textAlign: "center", padding: vMediaQuery ? "" : "20px" }}
              >
                <Typography variant="h4" sx={heading}>
                  GDR Consultancy Services
                </Typography>
              </Grid>
              <Grid item xs={2} md={3} lg={3}>
                <Stack
                  direction={"row"}
                  //spacing={vMediaQuery? 8:4}
                  sx={{
                    justifyContent: vMediaQuery ? "center" : "flex-end",
                    padding: vMediaQuery ? "0px" : "20px 40px",
                    marginTop: vMediaQuery ? "4px" : "10px",
                  }}
                >
                  {vMediaQuery ||
                      <ComBtn className={"btn"} onClick={handleClick} text={"Contact Us"} /> 
                    }
                  {vMediaQuery && 
                  <Tooltip title={"View Contact Info!"}>
                      <Avatar   sx={{ width: 32, height: 32 }}> 
                    <CallIcon onClick={handleClick}
                      sx={{
                        background: "green",
                        color: "#f0f4f5",
                        //borderRadius: "50%",
                        padding: "8px",
                      }}
                    />
                  </Avatar>
                  </Tooltip>
                  
                  }
                </Stack>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
        <div style={{ margin: vMediaQuery ? "110px 20px" : "180px 80px" }}>
          <Box
            sx={{ flexGrow: 1, padding: vMediaQuery ? "0px 16px" : "0px 60px" }}
          >
            <Grid container className="about-head">
              <Grid item xs={12}>
                <Typography
                  variant="h3"
                  sx={{
                    color: "whitesmoke",
                    fontWeight: 800,
                    fontSize: vMediaQuery ? "26px" : "48px",
                    fontFamily: "EB Garamond",
                  }}
                >
                  SERVICE-AS-A-SERVICE
                </Typography>
                <h1
                  style={{
                    color: "#d2f774",
                    fontWeight: 600,
                    fontSize: vMediaQuery ? "16px" : "32px",
                    marginTop: vMediaQuery ?"30px" :"50px"
                  }}
                >
                  We are Providing an{" "}
                  <strong style={{ fontWeight: 800 }}>
                    Microsoft Dynamics 
                    365 
                  </strong>
                 {" "}on GDR Consultancy Services
                </h1>
              </Grid>
            </Grid>
          </Box>
        </div>
      </header>
    </>
  );
};

export default Header;
